module.exports = __webpack_public_path__ + "static/media/Legacy of the Tiger.691e3b5f.png";